<template>
    <div class="x_t">
        <div v-if='text'>{{text}}</div>
    </div>
</template>

<script>
export default {
    name: "",
    computed: {},
    props:{
        text:String
    },
    data() {
        return {

        };
    },
    created() {},
    mounted() {},
    destroyed() {},
    methods: {},
    components: {},
};
</script>
<style lang="less" scoped>
.x_t {
    text-align: center;
    font-size: 48px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    box-sizing: border-box;
    padding: 75px 0;
    display: flex;
    // justify-content: center;
    // align-items: center;
    div{
        width:100%;
        // height: 100%;
    }
}
</style>










